/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Title1Inputs */

const en_usermanagement_permissions_title1 = /** @type {(inputs: Usermanagement_Permissions_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funds Access`)
};

/**
* | output |
* | --- |
* | "Funds Access" |
*
* @param {Usermanagement_Permissions_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_title1 = /** @type {((inputs?: Usermanagement_Permissions_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_title1(inputs)
});
export { usermanagement_permissions_title1 as "userManagement_permissions_title" }